$(document).ready(function() {
  $('.notice.dismissable .close').on('click', function () {
    $(this).parent().fadeOut();
  });
});
